const uniqueCommitId = require('unique-commit-id');

const userPublicPath = {
    yufa: `//storage.360buyimg.com/pubfree-bucket/jd-movie-h5/${uniqueCommitId.latest()}/`,
    online: '//misc.360buyimg.com/lt/newmovie/static'
};

const userAssetPath = {
    yufa: 'build-web',
    online: 'build-web'
};

// const buildType
const publicPath =
	process.env.NODE_ENV === 'production'
		? userPublicPath.online
		: userPublicPath.yufa;
const assetsRoot = process.env.NODE_ENV === 'production'
	? userAssetPath.online : userAssetPath.yufa;

module.exports = {
    build: {
    /**
     * 入口文件
     */
        entry: 'jsbundles/JDReactMovie.web.js',

        // publicPath: userPublicPath.yufa,

        // assetsRoot: userAssetPath.yufa,
		    // publicPath: `//storage.360buyimg.com/pubfree-bucket/jd-movie-h5/${uniqueCommitId.latest()}/`,
		    publicPath: '/', // 行云2.0
        assetsRoot,
        /**
     * js代码地址
     * @type {String}
     */
        src: 'jsbundles',
        /**
     * 生成的vm模板的配置
     * title: 生成模板的title
     * nofooter: 不包含京东公共底部
     * noheader: 不包含京东公共头部
     * downloadAppPlugIn: 不使用当打开m页面是唤起想要原生页面的能力
     */
        template: {
            title: '京东电影',
            nofooter: true,
            noheader: true,
            /* M下载浮层通用组件接入控制 */
            downloadAppPlugIn: false
        },
        /**
     * 是否要包含京东WebView的分享能力
     */
        includeJDShare: true
    },

    dev: {
        entry: 'jsbundles/JDReactMovie.web.js',
        publicPath: '/',
        assetsRoot: 'build-web',
        src: 'jsbundles',
        port: 3000,
        proxy: 'http://jdgameweb.m.jd.com/',
        template: {
            title: '京东电影',
            nofooter: true,
            noheader: true,
            downloadAppPlugIn: true
        },
        includeJDShare: true
    }
};
